import { UserState } from "../interface/redux-types";
import { TicketState } from "../interface/redux-types/TicketState";
import { ContractorState } from "../interface/redux-types/ContractorState";
import * as User from "./userStore";
import * as Ticket from "./ticketStore";
import * as Contractor from "./contractorStore";
import * as Transport from "./transportStore";
import * as Scale from "./scaleStore";
import * as Setting from "./settingStore";
import * as SmallQuantityTicket from "./smallQuantityTicketStore";
import * as HydrovacTicket from "./hydrovacTicketStore";
import * as RubbleTicket from "./rubbleTicketStore";
import * as StorageArea from "./storageAreaStore";
import { TransportState } from "../interface/redux-types/TransportState";
import { ScaleState } from "../interface/redux-types/ScaleState";
import { SettingState } from "../interface/redux-types/SettingState";
import { SmallQuantityTicketState } from "../interface/redux-types/SmallQuantityTicketState";
import { HydrovacTicketState } from "../interface/redux-types/HydrovacTicketState";
import { RubbleTicketState } from "../interface/redux-types/RubbleTicketState";
import { StorageAreaState } from "../interface/redux-types/StorageAreaState";

export interface ApplicationState {
  userStore: UserState | undefined;
  ticketStore: TicketState | undefined;
  contractorStore: ContractorState | undefined;
  transportStore: TransportState | undefined;
  scaleStore: ScaleState | undefined;
  settingStore: SettingState | undefined;
  smallQuantityTicketStore: SmallQuantityTicketState | undefined;
  hydrovacTicketStore: HydrovacTicketState | undefined;
  rubbleTicketStore: RubbleTicketState | undefined;
  storageAreaStore: StorageAreaState | undefined;
}
export const reducers = {
  userStore: User.reducer,
  ticketStore: Ticket.reducer,
  contractorStore: Contractor.reducer,
  transportStore: Transport.reducer,
  scaleStore: Scale.reducer,
  settingStore: Setting.reducer,
  smallQuantityTicketStore: SmallQuantityTicket.reducer,
  hydrovacTicketStore: HydrovacTicket.reducer,
  rubbleTicketStore: RubbleTicket.reducer,
  storageAreaStore: StorageArea.reducer,
};

export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
